import { EnvironmentProviders, inject, isDevMode, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { PlatformService } from '@rma/dashboard/generic/util/environment';
import { RMA_META_PIXEL_ID } from '../domain/facebook-pixel.token';
import { MetaPixelRouteTrackingService } from './meta-pixel-route-tracking.service';

function initialiseMetaPixelRouteTrackingProvider(
  metaPixelRouterTracking: MetaPixelRouteTrackingService,
  platformSerivce: PlatformService,
  metaPixelId: string,
) {
  return () => {
    if ((platformSerivce.isPlatformBrowser && metaPixelId) || isDevMode()) {
      metaPixelRouterTracking.init();
    }
  };
}

export function provideRmaMetaPixelRouteTracking(metaPixelId: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: RMA_META_PIXEL_ID, useValue: metaPixelId },
    provideAppInitializer(() => {
      const initializerFn = initialiseMetaPixelRouteTrackingProvider(
        inject(MetaPixelRouteTrackingService),
        inject(PlatformService),
        metaPixelId,
      );
      return initializerFn();
    }),
  ]);
}
